import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, setTokenHeader, headers, isExpiredJwt, getJwtFromCookies, getRoleJwt, renderRedirect } from "../../module_auth/AuthService"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { lazyReload } from '../common/BaseUtil';
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage } from "../../component/common/Modal"

export function ChangePwdByAdmin() {
    const [mbrId, setMbrId] = useState("");
    const [fullname, setFullname] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    
    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    //modal
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if(getJwtFromCookies() == null 
            || isExpiredJwt(getJwtFromCookies()) 
            || getRoleJwt(getJwtFromCookies()) != "ROLE_ADMIN"){
            setRedirect(true)
        } else { 
            setAccessToken(getJwtFromCookies())
            setTokenHeader(getJwtFromCookies())
        }
    }, []);

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function handleMbrId(event) {
        setMbrId(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function handlePassword(event) {
        setPassword(event.target.value);
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function changePasswordSubmit(event) {
        setAccessToken(getJwtFromCookies())
        fetch(basePort + '/post/change/pwd/admin',
            {method:'post', headers,
                      body:JSON.stringify({
                        fullname:fullname,
                        mbrId:mbrId,
                        newPassword:password,
                        newPasswordRepeat:passwordRepeat,
                    })})
                      .then(response => response.json())
                      .then(response => {
                        console.log(response.jwtToken)
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            lazyReload()
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    function closeModalBtn(){
        setShowModal(false)
    }

    function submitModalBtn(){
        setShowModal(false)
        changePasswordSubmit()
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>관리자페이지</span></li>
                            <li class="breadcrumb-item"><span>회원패스워드변경</span></li>
                        </ol>
                        <div class="card">
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <form><label class="form-label">이름:</label><input class="form-control" type="text" onChange={handleFullname} value={fullname}/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">회원아이디:</label><input class="form-control" type="text" onChange={handleMbrId} value={mbrId}/></form>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>비밀번호 변경</p>
                                <form><label class="form-label">새 비밀번호:</label><input class="form-control" type="password" onChange={handlePassword}/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">새 비밀번호 확인:</label><input class="form-control" type="password" onChange={handlePasswordRepeat}/></form>
                                <ul class="list-group"></ul>
                            </div>
                            <form style={{textAlign: 'center', marginBottom: '10px'}}><button class="btn btn-primary" type="button" onClick={clickModalBtn}>변경하기</button></form>
                        </div>
                        <ToastMessage show={showToast} msg={msgToast} />
                        <ModalMessage show={showModal} closeBtn={closeModalBtn} submitBtn={submitModalBtn} title={"비밀번호 변경"} msg={"비밀번호를 변경하시겠습나까?"} />
                    {/* end of container */}
                    </div>
                </section>
            </main>
        </div>
    );
}